module.exports = __webpack_public_path__ + "static/media/gif.f3b83372.svg";